import React from 'react';
import DimeCard from './DimeCard';
import "../containers/App";

const DimeCardList = ({ robots, onRated, onRouteChange, onRatingSubmitted }) => {
  return (
    <div className="masonry-wrapper">
      {robots.map((user) => (
        <div key={user.dime_id} className="masonry-item">
          <DimeCard
            onRouteChange={onRouteChange}
            onRated={onRated}
            onRatingSubmitted={onRatingSubmitted}
            dime_id={user.dime_id}
            category={user.category}
            rating={user.rating}
            image_key={user.image_key}
            rating_count={user.rating_count}
            reported={user.reported}
          />
        </div>
      ))}
    </div>
  );
};

export default DimeCardList;